import React, {Component} from "react";

import "./DocumentUploadingTab.css";
import {Button, message, Typography, Form, Row, Col} from "antd";

import {displayError, displayGenericError} from "../common/notifications";
import {deleteFile, setupSchedule, submitDocumentCorporateAccount, upload} from "../api/api";

import DayPicker from "react-day-picker";
import 'react-day-picker/lib/style.css';
import TimePicker from "antd/lib/time-picker";

import moment from "moment";



class ScheduleCorporateInfo extends Component {
    state = {

        selectedDay: null,
        selectTime: null
    }

    handleSubmit = () => {
        if (this.state.selectedDay == null || this.state.selectTime == null) {
            displayError("Please select date and time for video call")
        } else {
            setupSchedule({dateSelect: this.state.dateSelect, timeSelect: this.state.selectTime}).then(() => {
                this.props.handleCorporateSubmit('timeSchedule',this.state.dateSelect, this.state.selectTime)
            }).catch(displayGenericError);
        }

    };
    isSubmitButtonDisabled = () => {
        let response = true;

        if (this.state.selectedDay != null && this.state.selectTime != null) {
            response = false;
        }
        return response;
    }

    componentDidMount() {


    }

    isWeekend = (date) => {
        return date.getDay() === 6 || date.getDay() === 0;

    }
    handleTimeChange = (time, timeString) => {
        this.setState({
            selectTime: timeString
        })
    }
    handleDayClick = (day, {selected}) => {
        if (!this.isWeekend(day)) {
            this.setState({
                selectedDay: selected ? undefined : day,

            }, () => {

                this.setState({
                    dateSelect: moment(this.state.selectedDay).format('DD/MM/YYYY')
                });
            });
        }
    }

    render() {
        return (
            <div>
                <div>
                    <Row>
                        <Col>Please send the contact to
                            <a href="mailto:operations@brdgx.com"> operations@brdgx.com</a>
                            .Our customer service will help to update their info
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div style={{fontStyle: 'italic', marginTop:'15px'}}>We will contact you to conduct a Video Call for Identity
                                Verification.
                                Please select a time slot (SGT time) :
                            </div>
                        </Col>
                        <br/>
                    </Row>
                    <Row>
                        <Col md={8}>
                            <div>
                                <Form.Item
                                    label={this.state.selectedDay
                                        ? 'Select Date: ' + this.state.selectedDay.toLocaleDateString()
                                        : 'Select Date'}>
                                </Form.Item>

                            </div>

                            <DayPicker disabledDays={ [
                                new Date(),
                                { daysOfWeek: [0, 6] },
                                { before: new Date() }
                            ]} selectedDays={this.state.selectedDay} onDayClick={this.handleDayClick} />
                        </Col>
                        <Col md={12}>
                            <div>
                                <Form.Item
                                    label="Select time">

                                    <TimePicker
                                        minuteStep={15}
                                        onChange={this.handleTimeChange}
                                        disabledHours={() => [0, 1, 2, 3, 4, 5, 6, 7, 8,18, 19, 20, 21, 22, 23]}
                                        hideDisabledOptions={true}
                                        format={'HH:mm'}
                                    />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={24}>
                            <div  style={{fontStyle:'italic', marginTop:'15px', marginBottom:'15px'}}>
                                Before we proceed with your account opening, please kindly assist to provide the following onboarding documentations:
                            <br/>
                                <br/>1. &nbsp;Official company's registration document (within 3 month's validity period);
                                <br/>2. &nbsp;Board resolution and authorized signatories;
                                <br/>3. &nbsp;Proof of registered address (example: utility bills, bank statements within 6 months' validity period);

                            </div>
                        </Col>

                    </Row>
                    <Row gutter={24}>
                        <Col md={24}>
                            <div className="button-wrapper">
                                <Button className="bt-skip" onClick={this.props.prevTab}>
                                    Back
                                </Button>
                                <Button
                                    className="bt-next"
                                    type="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.isSubmitButtonDisabled()}>
                                    Submit
                                </Button>

                            </div>
                        </Col>
                    </Row>

                </div>


            </div>
        );
    }
}

export default ScheduleCorporateInfo;
